import { ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';

import { landingContent } from '../content';
import { site } from '../content/shared';
import type { Locale } from '../content/types';
import { localizedPaths } from '../lib/routes';
import { Container } from './Container';
import { LanguageSwitcher } from './LanguageSwitcher';

type FooterProps = {
  locale: Locale;
};

export function Footer({ locale }: FooterProps) {
  const content = landingContent[locale];
  const legalPath = localizedPaths.legalNotice[locale];
  const privacyPath = localizedPaths.dataProtection[locale];

  return (
    <footer className="site-footer">
      <Container className="site-footer__grid">
        <div className="site-footer__brand">
          <Link className="wordmark wordmark--footer" to={localizedPaths.landing[locale]}>
            <span className="wordmark__mark" aria-hidden="true">
              MD
            </span>
            <span>{site.name}</span>
          </Link>
          <p>{content.footer.summary}</p>
          <p className="site-footer__identity">
            {site.addressStreet}, {site.addressPostalCode} {site.addressLocality},{' '}
            {locale === 'de' ? site.addressCountryDe : site.addressCountryEn}
            <br />
            UID: {site.uid} · MWST: {site.vat}
          </p>
        </div>

        <div className="site-footer__column">
          <h2>{content.nav.contact}</h2>
          <a href={`mailto:${site.email}`}>{site.email}</a>
          <a href={`tel:${site.phoneSchema}`}>{site.phoneDisplay}</a>
          <a href={site.linkedin} rel="noreferrer" target="_blank">
            <ExternalLink aria-hidden="true" size={16} />
            {content.nav.linkedin}
          </a>
        </div>

        <div className="site-footer__column">
          <h2>{content.footer.legalNotice}</h2>
          <Link to={legalPath}>{content.footer.legalNotice}</Link>
          <Link to={privacyPath}>{content.footer.dataProtection}</Link>
          <div>
            <p className="site-footer__language-label">{content.footer.language}</p>
            <LanguageSwitcher currentLocale={locale} />
          </div>
        </div>
      </Container>
      <Container className="site-footer__bottom">
        <p>
          © {new Date().getFullYear()} {site.name}. {content.footer.copyright}
        </p>
      </Container>
    </footer>
  );
}
